import BotDialogType from '../../core/type/dialog/BotDialogType';
import ButtonInputType from '../../core/type/input/ButtonInputType';
import UserDialogType from '../../core/type/dialog/UserDialogType';
import Interceptor from '../../core/type/operation/Interceptor';
import { sendBotResponse } from './util';
import Switch from '../../core/type/operation/Switch';
import Case from '../../core/type/operation/Case';
import TextInputType from '../../core/type/input/TextInputType';

export default [

  new BotDialogType({
    message: `Quanto mais detalhes você nos passar com relação as suas necessidades, mais assertivo será o nosso direcionamento. 
    O que acha de nos contar um pouco sobre os seus objetivos?`,
    checkpoint: true,
  }),

  new TextInputType({
    placeholder: 'Descreva sua necessidade.',
    key: 'description',
    textareaMode: true,
    optional: true,
  }),

  new BotDialogType({
    message: 'Para finalizar, precisamos confirmar só mais alguns dados. Já estamos quase acabando!',
  }),

  new BotDialogType({
    message: 'Você pode me informar a cidade da sua empresa?',
    checkpoint: true,
  }),

  new TextInputType({
    placeholder: 'Comece a digitar sua cidade',
    key: 'city',
    suggestionsId: 'cities',
    filtered: true,
    minLength: 1,
    onSuggestionSubmit: true,
    maxSuggestions: 50,
  }),
  new Interceptor(async (data) => new Promise((resolve) => {
    if (data.options.cities) {
      const city = data.options.cities.find((c) => c.id === data.city);
      if (city) {
        resolve({
          ...data,
          city: city.value,
          state: city.state,
          state_full: city.state_full,
        });
      } else {
        resolve({
          ...data,
          city: data.city,
          state: 'N/D',
          state_full: '',
        });
      }
    } else {
      resolve({
        ...data,
        city: data.city,
        state: 'N/D',
        state_full: '',
      });
    }
  })),

  new UserDialogType({
    message: 'Estamos localizados em #{city}, #{state_full}.',
  }),

  new BotDialogType({
    message: `Pode me confirmar se seu e-mail e telefone estão corretos?<br/>
    Email: #{email}<br/> Telefone: #{phone}`,
    checkpoint: true,
  }),

  new ButtonInputType({
    key: 'project_contact_option',
    buttons: [
      { value: 'CORRECT', text: 'Sim, estão corretos.' },
      { value: 'INCORRECT', text: 'Não, preciso alterar.' },
    ],
  }),

  new BotDialogType({
    message: '',
    checkpoint: true,
  }),

  new Switch({
    ref: 'project_contact_option',
    cases: [
      new Case({
        express: '\'$v\' === \'INCORRECT\'',
        components: [
          new BotDialogType({
            message: 'Tudo bem, me confirma o seu email primeiro.',
            checkpoint: true,
          }),

          new TextInputType({
            placeholder: '',
            validation: 'email',
            key: 'email',
            defaultData: 'email',
          }),

          new UserDialogType({
            message: '#{email}',
          }),

          new BotDialogType({
            message: 'Agora o seu celular.',
            checkpoint: true,
          }),

          new TextInputType({
            placeholder: '',
            validation: 'phone',
            key: 'phone',
            defaultData: 'phone',
            mask: '(99) 99999-9999',
          }),

          new UserDialogType({
            message: '#{phone}',
          }),
        ],
      }),
    ],
  }),

  sendBotResponse(true),

  new BotDialogType({
    message: 'Ok, parece que deu tudo certo. Aguarde enquanto registramos todas as informações...',
    checkpoint: true,
  }),

  new Interceptor(async (data) => new Promise(() => {
    window.fbq('track', 'ClintzFinalizou');
    setTimeout(() => {
      window.location.replace(`https://grow.clint.digital/welcome/obrigado?name=${data.first_name}`);
    }, 2000);
  })),
];
